import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-products-component',
  templateUrl: './products-component.component.html',
  styleUrls: ['./products-component.component.css'],
})
export class ProductsComponentComponent {
  constructor(private router:Router){}
  @Input() title!: string;
  @Input() productList: any;
  selectedTab: string = 'all';

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  public ViewProduct(id:string){
    this.router.navigate(['/products',id]);
  }
}
